import React from 'react';

type FeaturedCardProps = {
  title: string;
  imgUrl: string;
  onClickCallback: () => void;
};

const FeaturedCard = ({ title, imgUrl, onClickCallback }: FeaturedCardProps) => (
  <div
    onClick={onClickCallback}
    className="bg-gradient-to-b from-white/30 to-white/10 sm:to-transparent p-5 rounded-2xl sm:rounded-2xl cursor-pointer
    flex flex-col gap-5 w-48"
  >
    <div className="flex items-center justify-between">
      <span className="text-white mr-3 text-sm sm:text-base font-bold leading-none">{title}</span>
    </div>
    <img className="w-full" alt={title} src={imgUrl} />
  </div>
);

export default FeaturedCard;
